import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("mask", {
  id: "a",
  width: "19",
  height: "18",
  x: "0",
  y: "0",
  maskUnits: "userSpaceOnUse",
  style: {"mask-type":"alpha"}
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#D9D9D9",
    d: "M.5 0h18v18H.5z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#2E3137",
    d: "M2 18v-3h15v3zm3-6h1.05l5.85-5.831L10.831 5.1 5 10.95zm-1.5 1.5v-3.187l8.4-8.382q.206-.206.478-.318t.572-.113.581.113.506.337L15.07 3q.226.207.328.487.103.282.103.582 0 .281-.103.553a1.4 1.4 0 0 1-.328.497L6.688 13.5z"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }